'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Truncate string to given length and append ellipsis
 * @param {number} limit Maximum allowed string length
 * @param {string} string The string to truncate
 * @returns {string} Truncated string if longer than limit; input otherwise.
 */
function truncate(limit, string) {
  if (limit > string.length) {
    return string;
  }

  return "".concat(string.substring(0, limit), "...");
}

exports.truncate = truncate;
//# sourceMappingURL=truncate.js.map
